import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreSyncSecurityAlertsPostSlice } from './post';

export const coreSyncSecurityAlertsPostSliceReducers = combineReducers({
	post: coreSyncSecurityAlertsPostSlice.asyncReducers
});

export const coreSyncSecurityAlertsPostSliceWatchers = combineAllWatchers([
	coreSyncSecurityAlertsPostSlice.asyncWatchers
]);
